import { Card, Center, ScrollArea, Stack, Text } from "@mantine/core";
import {
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
  SortingState
} from "@tanstack/react-table";
import { useState } from "react";
import NoData from "@/components/no-data";
import Table from "@/components/table";
import TablePagination from "@/components/table/TablePagination";
import tableColumns from "./Columns";
import { TDesafioProcessado } from "../hooks/useDesafiosRelatorio";

interface RelatorioVisaoGeralDesafiosTableProperties {
  data: TDesafioProcessado[];
  isLoading: boolean;
}

const DEFAULT_SORTING: SortingState = [{ id: "createdAt", desc: true }];

const RelatorioVisaoGeralDesafiosTable = ({ data, isLoading }: RelatorioVisaoGeralDesafiosTableProperties) => {
  const [sorting, setSorting] = useState<SortingState>(DEFAULT_SORTING);

  const table = useReactTable({
    data,
    columns: tableColumns,
    state: {
      sorting
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel()
  });

  // Criar tableHandlers para o componente TablePagination
  const tableHandlers = {
    table,
    data: {
      entries: data,
      firstDocument: undefined,
      lastDocument: undefined,
      total: data.length
    },
    isLoading,
    error: null,
    filters: []
  };

  const isEmpty = !isLoading && data.length === 0;

  return (
    <>
      <Card.Section withBorder>
        <ScrollArea>
          <Table table={table} isLoading={isLoading} />
        </ScrollArea>
        {isEmpty && (
          <Center m="lg">
            <NoData m="md">
              <Stack gap="xs">
                <Text c="dimmed">Nenhum desafio encontrado com o filtro aplicado!</Text>
              </Stack>
            </NoData>
          </Center>
        )}
      </Card.Section>
      <Card.Section withBorder>
        <TablePagination tableHandlers={tableHandlers} />
      </Card.Section>
    </>
  );
};

export default RelatorioVisaoGeralDesafiosTable;
